export const getCardVariantDetails = (variant = {}) => ({
  ...variant,
  img: `${variant.photos[0] ? variant.photos[0].path : undefined}`,
  detail: [
    {
      icon: 'icon-car',
      text: variant.name || '-'
    },
    {
      icon: 'icon-car-seat',
      text: `${variant.seats || '-'} Seats, ${variant.doors || '-'} Doors`
    },
    {
      icon: 'icon-car-engine',
      text: variant.engineDescription || '-'
    },
    {
      icon: 'icon-car-transmission',
      text: variant.transmission || '-'
    },
    {
      icon: 'icon-car-fuel',
      text: variant.fuelType || '-'
    },
    {
      icon: 'icon-car-fuel',
      text: `${variant.fuelConsumptionCombined || '-'} l/100 km`
    }
  ]
});

export const getSummaryVariantDetails = (variant = {}, quote = {}) => [
  { label: 'Model Year', value: variant.modelYear },
  {
    label: 'Start Km',
    value: variant.startOdometer ? `${variant.startOdometer} km` : undefined
  },
  { label: 'Body Type', value: quote.bodyType },
  { label: 'Doors', value: variant.doors },
  { label: 'Seats', value: variant.seats },
  {
    label: 'Colour Perf',
    value: quote.exteriorColour ? quote.exteriorColour.name : '-'
  },
  { label: 'Transmission', value: variant.transmission },
  { label: 'Gears', value: variant.gears },
  { label: 'Drive Type', value: variant.driveType },
  { label: 'Engine CC', value: variant.fuelTankCapacity },
  { label: 'Engine Litres', value: variant.engineSize },
  { label: 'Cylinders', value: variant.engineCylinders },
  { label: 'Induction', value: variant.induction },
  { label: 'Power Output', value: variant.power },
  { label: 'Torque', value: variant.torque },
  { label: 'Kerb Weight (kg)', value: variant.grossUnloadedWeight },
  { label: 'Gross Weight (kg)', value: variant.grossLoadedWeight },
  { label: 'Fuel Type', value: variant.fuelType },
  { label: 'Economy (L/100km)', value: variant.fuelConsumption },
  { label: 'C02 Emissions (g/km)', value: variant.co2Emissions },
  { label: 'Green Star Rating', value: variant.greenStarRating },
  { label: 'Ancap Rating', value: variant.ancapRating }
];
